import React from 'react'
import Modal from 'react-modal'

// ネタばれ防止用に、ミッションやアイテムの情報を隠すモーダル
const NetabareModal = ({isOpen, onClose, onLeave}) => {
  return (
    <Modal
        isOpen={isOpen}
        onRequestClose={() => {onClose()}}
        className="bg-white p-6 rounded-lg shadow-lg mx-auto mt-20 relative"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-md flex justify-center items-center"
    >
        {/* ✕ボタン */}
        <button className='absolute top-4 right-4 text-gray-600 text-lg hover:text-gray-800' onClick={() => {onLeave()}}>
            <i className='bi bi-x-lg'></i>
        </button>

        <div className='text-center px-6'>
            <h2 className='font-bold text-purple-800 text-xl mb-2'><i className='bi bi-shield-lock me-2'></i>ネタバレ防止</h2>
            <p className='text-gray-600 text-base text-left mb-6'>
                ご購入いただいたゲームパックのネタバレを含みます。<br/>
                ミッションやアイテムの情報を隠しています。<br/>
                表示してよろしいですか？<br/>
            </p>

            <div className='grid grid-cols-2 gap-4'>
                <button className='bg-gray-300 hover:bg-gray-400 text-gray-800 rounded-lg px-4 py-2' onClick={() => {onClose()}}>表示する</button>
                <button className='bg-purple-500 hover:bg-purple-600 text-white rounded-lg px-4 py-2' onClick={() => {onLeave()}}>表示しない</button>
            </div>
        </div>
    </Modal>
  )
}

export default NetabareModal